import { render, staticRenderFns } from "./AuthIcon.vue?vue&type=template&id=828134b0&scoped=true"
import script from "./AuthIcon.vue?vue&type=script&lang=js"
export * from "./AuthIcon.vue?vue&type=script&lang=js"
import style0 from "./AuthIcon.vue?vue&type=style&index=0&id=828134b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828134b0",
  null
  
)

export default component.exports